module.exports = __webpack_public_path__ + "static/media/16UNODC36.3cb314d0.jpg";